// extracted by mini-css-extract-plugin
module.exports = {"list-wrapper":"list-wrapper__1RY_3","list":"list__2gyWY","list-header":"list-header__1v5GN","list-body":"list-body__zqkQV"};